export default function Features() {
  const features = [
    {
      title: 'Plataforma',
      description: 'Automobilista 2',
      icon: 'ri-gamepad-line'
    },
    {
      title: 'Categoria',
      description: 'Ginetta G55 GT4 Supercup',
      icon: 'ri-steering-2-line'
    },
    {
      title: 'Setup',
      description: 'Aberto',
      icon: 'ri-settings-3-line'
    },
    {
      title: 'Formato',
      description: 'Individual',
      icon: 'ri-user-line'
    }
  ];

  const details = [
    {
      title: 'Início previsto',
      date: '25 de fevereiro de 2026',
      description: 'Primeira etapa oficial em Brands Hatch abre a temporada com toda a emoção e competitividade que você espera de um campeonato sério.'
    },
    {
      title: 'Dias oficiais',
      date: 'Quartas-feiras (20h/21h)',
      subtitle: 'Horário de Brasília',
      description: 'Organize sua agenda e prepare-se para disputar cada posição na pista com os melhores pilotos virtuais do Brasil.'
    }
  ];

  return (
    <section id="features" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Visão Geral do Campeonato
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
            O Campeonato Brasileiro de Ginetta G55 Supercup 2026 é a competição mais organizada e competitiva da categoria GT4 no simracing brasileiro. Com formato individual aberto a todos os pilotos, nossa liga oferece uma experiência profissional completa, desde a seletiva classificatória até as etapas oficiais do calendário.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12 sm:mb-16">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-gray-900 text-white p-6 sm:p-8 rounded-xl hover:bg-gray-800 transition-all duration-300 hover:shadow-xl"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-3xl text-orange-500`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold mb-2">{feature.title}</h3>
              <p className="text-sm sm:text-base text-gray-300">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Details Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8">
          {details.map((detail, index) => (
            <div 
              key={index}
              className="bg-gray-50 p-6 sm:p-8 rounded-xl border border-gray-200 hover:border-orange-500 transition-all duration-300"
            >
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3">{detail.title}</h3>
              <p className="text-base sm:text-lg font-semibold text-orange-500 mb-2">{detail.date}</p>
              {detail.subtitle && (
                <p className="text-sm sm:text-base text-gray-600 mb-3">{detail.subtitle}</p>
              )}
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{detail.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
